module.exports = __webpack_public_path__ + "img/cases-brand-yanghe-1.eb3960ee.jpg";